import WBTC from 'assets/assets-list/wbtc-icon.png'
import USDC from 'assets/assets-list/usdc-icon.png'
import USDT from 'assets/assets-list/usdt-icon.png'
import DAI from 'assets/assets-list/dai-icon.png'
import LINK from 'assets/assets-list/link-icon.png'
import ETH from 'assets/assets-list/ethereum-icon.png'
import MATIC from 'assets/assets-list/polygon-icon.png'
import PHTR from 'assets/assets-list/phtr-logo.png'
import ePHTR from 'assets/assets-list/ephtr-icon.png'
import JOE from 'assets/assets-list/joe-icon.png'
import QI from 'assets/assets-list/qi-icon.png'
import WAVAX from 'assets/assets-list/avax-icon.png'
import CAI from 'assets/assets-list/cai-icon.png'
import SAVAX from 'assets/assets-list/savax-icon.png'
import XAVA from 'assets/assets-list/xava-icon.png'
import ARB from 'assets/assets-list/arb-icon.png'
import PENDLE from 'assets/assets-list/pendle-icon.png'
import GMX from 'assets/assets-list/gmx-icon.png'
import OP from 'assets/assets-list/op-icon.png'
import stMATIC from 'assets/assets-list/stMATIC-icon.png'
import MATICX from 'assets/assets-list/maticx-icon.webp'
import wstETH from 'assets/assets-list/wstETH-icon.webp'
import weETH from 'assets/assets-list/weETH-icon.webp'
import rETH from 'assets/assets-list/reth-icon.webp'
import ezETH from 'assets/assets-list/ezETH-icon.webp'
import cbETH from 'assets/assets-list/cbeth-icon.webp'
import sfrxETH from 'assets/assets-list/sfrxETH-icon.webp'
import rsETH from 'assets/assets-list/rsETH-icon.webp'
import rswETH from 'assets/assets-list/rswETH-icon.webp'
import mETH from 'assets/assets-list/meth-icon.webp'
import ETHx from 'assets/assets-list/ethx-icon.webp'
import ARTX from 'assets/assets-list/artx-ai-icon.png'
import BRETT from 'assets/assets-list/brett-icon.webp'
import TRUMP from 'assets/assets-list/trump-icon.png'
import Mog from 'assets/assets-list/mog-icon.webp'
import DOGE from 'assets/assets-list/doge-icon.webp'
import FLOKI from 'assets/assets-list/floki-icon.webp'
import USDbC from 'assets/assets-list/usdbc-icon.png'
import ZETA from 'assets/network-icons/zetachain-icon.png'
import SHIB from 'assets/assets-list/shib-icon.webp'
import PEPE from 'assets/assets-list/pepe-icon.webp'
import GGAVAX from 'assets/assets-list/ggavax-icon.png'
import COQ from 'assets/assets-list/coq-icon.webp'
import GGP from 'assets/assets-list/ggp-icon.png'
import CLY from 'assets/assets-list/cly-icon.png'
import GAME from 'assets/assets-list/game-icon.png'
import COOKIE from 'assets/assets-list/cookie-icon.png'
import LUNA from 'assets/assets-list/luna-icon.png'
import VADER from 'assets/assets-list/vader-ai-icon.png'
import TOSHI from 'assets/assets-list/toshi-icon.webp'
import VIRTUAL from 'assets/assets-list/virtual-icon.png'
import AIXBT from 'assets/assets-list/aixbt-icon.png'
import REI from 'assets/assets-list/rei-icon.png'
import LAY from 'assets/assets-list/lay-icon.png'
import CLANKER from 'assets/assets-list/clanker-icon.png'
import SEKOIA from 'assets/assets-list/sekoia-icon.png'
import AIXCB from 'assets/assets-list/aixcb-icon.png'
import JMX from 'assets/assets-list/jmx-icon.webp'
import WIF from 'assets/assets-list/wif-icon.webp'
import SPX from 'assets/assets-list/spx-icon.webp'
import MIGGLES from 'assets/assets-list/miggles-icon.webp'
import BENJI from 'assets/assets-list/benji-icon.webp'
import DEGEN from 'assets/assets-list/degen-icon.webp'
import SKI from 'assets/assets-list/ski-icon.webp'
import MEME from 'assets/assets-list/meme-icon.webp'
import Neiro from 'assets/assets-list/neiro-icon.webp'
import BONK from 'assets/assets-list/bonk-icon.webp'
import BabyDoge from 'assets/assets-list/baby-doge-icon.webp'
import CAT from 'assets/assets-list/cat-icon.webp'
import ELON from 'assets/assets-list/elon-icon.webp'
import KEYCAT from 'assets/assets-list/keycat-icon.webp'
import DOGINME from 'assets/assets-list/doginme-icon.webp'
import JOOCE from 'assets/assets-list/jooce-icon.webp'

import { type Address, zeroAddress } from 'viem'
import {
  arbitrum,
  avalanche,
  avalancheFuji,
  base,
  bsc,
  mainnet,
  optimism,
  polygon,
  polygonMumbai,
} from 'viem/chains'

export const assetsList: { [key: string]: { icon: string; symbol: string; chainId: number } } = {
  //PRODUCTS
  '0x48f88a3fe843ccb0b5003e70b4192c1d7448bef0': { icon: CAI, symbol: 'CAI', chainId: avalanche.id }, //CAI
  '0x8e991e9edc300a538ce72186f5bcbc94f4bb9c80': {
    icon: ARTX,
    symbol: 'ARTXAI',
    chainId: arbitrum.id,
  }, //ARTXAI
  '0x83190636c344cf1220ffcbfc0c1198f7867b3667': {
    icon: JMX,
    symbol: 'JMX',
    chainId: base.id,
  }, //JMX
  //TEST ASSETS
  '0x742DfA5Aa70a8212857966D491D67B09Ce7D6ec7': {
    icon: USDC,
    symbol: 'USDC',
    chainId: polygonMumbai.id,
  }, //test USDC(mumbai-testnet)
  '0x4a0d1092e9df255cf95d72834ea9255132782318': {
    icon: USDC,
    symbol: 'USDC',
    chainId: avalancheFuji.id,
  }, //test USDC(fuji-testnet)

  //MAINNET ASSETS
  '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': { icon: USDC, symbol: 'USDC', chainId: mainnet.id },
  '0x514910771af9ca656af840dff83e8264ecf986ca': { icon: LINK, symbol: 'LINK', chainId: mainnet.id }, //LINK
  '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599': { icon: WBTC, symbol: 'WBTC', chainId: mainnet.id }, //WBTC
  '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': { icon: ETH, symbol: 'WETH', chainId: mainnet.id }, //WETH
  '0x0000000000000000000000000000000000000000': { icon: ETH, symbol: 'ETH', chainId: mainnet.id }, //ETH
  '0x3b9805E163b3750e7f13a26B06F030f2d3b799F5': {
    icon: ePHTR,
    symbol: 'ePHTR',
    chainId: mainnet.id,
  }, //EPHTR
  '0xd5f7838f5c461feff7fe49ea5ebaf7728bb0adfa': { icon: mETH, symbol: 'mETH', chainId: mainnet.id }, //mETH
  '0xa1290d69c65a6fe4df752f95823fae25cb99e5a7': {
    icon: rsETH,
    symbol: 'rsETH',
    chainId: mainnet.id,
  }, //rsETH
  '0xa35b1b31ce002fbf2058d22f30f95d405200a15b': { icon: ETHx, symbol: 'ETHx', chainId: mainnet.id }, //ETHx
  '0xfae103dc9cf190ed75350761e95403b7b8afa6c0': {
    icon: rswETH,
    symbol: 'rswETH',
    chainId: mainnet.id,
  }, //rswETH

  //AVALANCHE ASSETS
  '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e': {
    icon: USDC,
    symbol: 'USDC',
    chainId: avalanche.id,
  },
  '0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd': { icon: JOE, symbol: 'JOE', chainId: avalanche.id }, //JOE
  '0x8729438eb15e2c8b576fcc6aecda6a148776c0f5': { icon: QI, symbol: 'QI', chainId: avalanche.id }, //QI
  '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7': {
    icon: WAVAX,
    symbol: 'WAVAX',
    chainId: avalanche.id,
  }, //WAVAX
  '0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be': {
    icon: SAVAX,
    symbol: 'sAVAX',
    chainId: avalanche.id,
  }, //sAVAX
  '0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4': {
    icon: XAVA,
    symbol: 'XAVA',
    chainId: avalanche.id,
  }, //XAVA
  '0x420fca0121dc28039145009570975747295f2329': {
    icon: COQ,
    symbol: 'COQ',
    chainId: avalanche.id,
  }, //COQ
  '0xa25eaf2906fa1a3a13edac9b9657108af7b703e3': {
    icon: GGAVAX,
    symbol: 'ggAVAX',
    chainId: avalanche.id,
  }, //ggAVAX
  '0x69260b9483f9871ca57f81a90d91e2f96c2cd11d': {
    icon: GGP,
    symbol: 'GGP',
    chainId: avalanche.id,
  }, //GGP
  '0xec3492a2508ddf4fdc0cd76f31f340b30d1793e6': {
    icon: CLY,
    symbol: 'CLY',
    chainId: avalanche.id,
  }, //CLY

  //ARBITRUM ASSETS
  '0x912ce59144191c1204e64559fe8253a0e49e6548': { icon: ARB, symbol: 'ARB', chainId: arbitrum.id }, //ARB
  '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8': {
    icon: PENDLE,
    symbol: 'PENDLE',
    chainId: arbitrum.id,
  }, //PENDLE
  '0xf97f4df75117a78c1a5a0dbb814af92458539fb4': {
    icon: LINK,
    symbol: 'LINK',
    chainId: arbitrum.id,
  }, //LINK
  '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a': { icon: GMX, symbol: 'GMX', chainId: arbitrum.id }, //GMX

  '0x5979d7b546e38e414f7e9822514be443a4800529': {
    icon: wstETH,
    symbol: 'wstETH',
    chainId: arbitrum.id,
  }, //wstETH
  '0x35751007a407ca6feffe80b3cb397736d2cf4dbe': {
    icon: weETH,
    symbol: 'weETH',
    chainId: arbitrum.id,
  }, //weETH
  '0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8': {
    icon: rETH,
    symbol: 'rETH',
    chainId: arbitrum.id,
  }, //rETH
  '0x2416092f143378750bb29b79ed961ab195cceea5': {
    icon: ezETH,
    symbol: 'ezETH',
    chainId: arbitrum.id,
  }, //ezETH
  '0x1debd73e752beaf79865fd6446b0c970eae7732f': {
    icon: cbETH,
    symbol: 'cbETH',
    chainId: arbitrum.id,
  }, //cbETH
  '0x95ab45875cffdba1e5f451b950bc2e42c0053f39': {
    icon: sfrxETH,
    symbol: 'sfrxETH',
    chainId: arbitrum.id,
  }, //sfrxETH
  '0x4186bfc76e2e237523cbc30fd220fe055156b41f': {
    icon: rsETH,
    symbol: 'rsETH',
    chainId: arbitrum.id,
  }, //rsETH
  '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1': { icon: DAI, symbol: 'DAI', chainId: arbitrum.id }, //DAI
  '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f': {
    icon: WBTC,
    symbol: 'WBTC',
    chainId: arbitrum.id,
  }, //WBTC on arb
  '0xaf88d065e77c8cc2239327c5edb3a432268e5831': {
    icon: USDC,
    symbol: 'USDC',
    chainId: arbitrum.id,
  }, //USDC on arb

  '0xa6c895eb332e91c5b3d00b7baeeaae478cc502da': {
    icon: weETH,
    symbol: 'weETH',
    chainId: arbitrum.id,
  }, //SY-weETH
  '0xf176fb51f4eb826136a54fdc71c50fcd2202e272': {
    icon: rsETH,
    symbol: 'rsETH',
    chainId: arbitrum.id,
  }, //SY-rsETH
  '0x0de802e3d6cc9145a150bbdc8da9f988a98c5202': {
    icon: ezETH,
    symbol: 'ezETH',
    chainId: arbitrum.id,
  }, //SY-ezETH

  '0xb8b0a120f6a68dd06209619f62429fb1a8e92fec': {
    icon: weETH,
    symbol: 'weETH',
    chainId: arbitrum.id,
  }, //PT-weETH
  '0xafd22f824d51fb7eed4778d303d4388ac644b026': {
    icon: rsETH,
    symbol: 'rsETH',
    chainId: arbitrum.id,
  }, //PT-rsETH
  '0x8ea5040d423410f1fdc363379af88e1db5ea1c34': {
    icon: ezETH,
    symbol: 'ezETH',
    chainId: arbitrum.id,
  }, //PT-ezETH
  '0xd7e810aed2988b8a7ea0187d55c939110b178521': {
    icon: ezETH,
    symbol: 'sETH',
    chainId: arbitrum.id,
  }, //PT-ezETH//PT-sETH-ptezETHSilo

  //INFO: PPSI assets
  '0x01928bf4378e0303a133904391e2d72121ae5028': {
    icon: rsETH,
    symbol: 'pwPENDLE-LPT-rsETH',
    chainId: arbitrum.id,
  }, //pwPENDLE-LPT-rsETH
  '0x1746b55cb752df539a10f71772ca725fec3fe63d': {
    icon: ezETH,
    symbol: 'pwPENDLE-LPT-ezETH',
    chainId: arbitrum.id,
  }, //pwPENDLE-LPT-ezETH
  '0x2ccfce9be49465cc6f947b5f6ac9383673733da9': {
    icon: ezETH,
    symbol: 'PT-ezETH-26SEP2024',
    chainId: arbitrum.id,
  }, //PT-ezETH-26SEP2024
  '0x30c98c0139b62290e26ac2a2158ac341dcaf1333': {
    icon: rsETH,
    symbol: 'PT-rsETH-26SEP2024',
    chainId: arbitrum.id,
  }, //PT-rsETH-26SEP2024
  // '0xb8b0a120f6a68dd06209619f62429fb1a8e92fec': {
  //   icon: weETH,
  //   symbol: 'PT-weETH-26SEP2024',
  //   chainId: arbitrum.id,
  // }, //PT-weETH-26SEP2024
  '0xd5dd6244c65688bbdff156bf7650ced3fb05823a': {
    icon: weETH,
    symbol: 'PT-weETH-26SEP2024',
    chainId: arbitrum.id,
  }, //pwPENDLE-LPT-eETH

  //OPTIMISM ASSETS
  '0x4200000000000000000000000000000000000042': { icon: OP, symbol: 'OP', chainId: optimism.id }, //OP
  '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6': {
    icon: LINK,
    symbol: 'LINK',
    chainId: optimism.id,
  }, //LINK
  //MATIC
  '0xfa68fb4628dff1028cfec22b4162fccd0d45efb6': {
    icon: MATICX,
    symbol: 'MATICX',
    chainId: polygon.id,
  }, //MATICX
  '0x3a58a54c066fdc0f2d55fc9c89f0415c92ebf3c4': {
    icon: stMATIC,
    symbol: 'stMATIC',
    chainId: polygon.id,
  }, //stMATIC

  //INFO: BASE CHAIN

  '0x532f27101965dd16442e59d40670faf5ebb142e4': {
    icon: BRETT,
    symbol: 'BRETT',
    chainId: base.id,
  }, //BRETT

  '0x57f5fbd3de65dfc0bd3630f732969e5fb97e6d37': {
    icon: TRUMP,
    symbol: 'TRUMP',
    chainId: base.id,
  }, //TRUMP
  '0x2da56acb9ea78330f947bd57c54119debda7af71': {
    icon: Mog,
    symbol: 'Mog',
    chainId: base.id,
  }, //Mog
  '0x61a287fc37559c71ba7cf6c35f3a5716dc91d265': {
    icon: Mog,
    symbol: 'pwMog-1',
    chainId: base.id,
  }, //pwMog(old)
  '0x66af6b21aad17849bf8db8844b26d5cdd1b7ac86': {
    icon: Mog,
    symbol: 'pwMog-2',
    chainId: base.id,
  }, //pwMog(old)
  '0xeff13712b5efacf5213f9a76bc58d89f037d71d3': {
    icon: Mog,
    symbol: 'pwMog-3',
    chainId: base.id,
  }, //pwMog(new)
  '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca': {
    icon: USDbC,
    symbol: 'USDbC',
    chainId: base.id,
  },

  '0x1c4cca7c5db003824208adda61bd749e55f463a3': {
    icon: GAME,
    symbol: 'GAME',
    chainId: base.id,
  },
  '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f': {
    icon: COOKIE,
    symbol: 'COOKIE',
    chainId: base.id,
  },
  '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4': {
    icon: LUNA,
    symbol: 'LUNA',
    chainId: base.id,
  },
  '0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870': {
    icon: VADER,
    symbol: 'VADER',
    chainId: base.id,
  },
  '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4': {
    icon: TOSHI,
    symbol: 'TOSHI',
    chainId: base.id,
  },
  '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b': {
    icon: VIRTUAL,
    symbol: 'VIRTUAL',
    chainId: base.id,
  },
  '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825': {
    icon: AIXBT,
    symbol: 'AIXBT',
    chainId: base.id,
  },
  '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd': {
    icon: REI,
    symbol: 'REI',
    chainId: base.id,
  },
  '0xb89d354ad1b0d95a48b3de4607f75a8cd710c1ba': {
    icon: LAY,
    symbol: 'LAY',
    chainId: base.id,
  },
  '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb': {
    icon: CLANKER,
    symbol: 'CLANKER',
    chainId: base.id,
  },
  '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7': {
    icon: SEKOIA,
    symbol: 'SEKOIA',
    chainId: base.id,
  },
  '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f': {
    icon: AIXCB,
    symbol: 'AIXCB',
    chainId: base.id,
  },

  //BSC
  '0xba2ae424d960c26247dd6c32edc70b295c744c43': {
    icon: DOGE,
    symbol: 'DOGE',
    chainId: bsc.id,
  }, //DOGE
  '0xa697e272a73744b343528c3bc4702f2565b2f422': {
    icon: BONK,
    symbol: 'Bonk',
    chainId: bsc.id,
  }, //Bonk
  '0xfb5b838b6cfeedc2873ab27866079ac55363d37e': {
    icon: FLOKI,
    symbol: 'FLOKI',
    chainId: bsc.id,
  }, //FLOKI
  // INFO: JMX assets
  '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86': {
    icon: WIF,
    symbol: 'WIF',
    chainId: base.id,
  }, //WIF
  '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c': {
    icon: SPX,
    symbol: 'SPX',
    chainId: base.id,
  }, //SPX
  '0xb1a03eda10342529bbf8eb700a06c60441fef25d': {
    icon: MIGGLES,
    symbol: 'MIGGLES',
    chainId: base.id,
  }, //MIGGLES
  '0xbc45647ea894030a4e9801ec03479739fa2485f0': {
    icon: BENJI,
    symbol: 'BENJI',
    chainId: base.id,
  }, //BENJI
  '0x4ed4e862860bed51a9570b96d89af5e1b0efefed': {
    icon: DEGEN,
    symbol: 'DEGEN',
    chainId: base.id,
  }, //DEGEN
  '0x768be13e1680b5ebe0024c42c896e3db59ec0149': {
    icon: SKI,
    symbol: 'SKI',
    chainId: base.id,
  }, //SKI
  // INFO: JMX based assets
  '0x1fb8432d5e243986df8ab85aea1dff5030ac54b6': {
    icon: COQ,
    symbol: 'COQ',
    chainId: base.id,
  }, //bCOQ
  '0x87eedc11abe771273246172a4a922dea68796c2d': {
    icon: TRUMP,
    symbol: 'TRUMP',
    chainId: base.id,
  }, //bTRUMP
  '0x7f3b6f46503a7fe22cbed587d94b5566c99a3f07': {
    icon: MEME,
    symbol: 'MEME',
    chainId: base.id,
  }, //bMEME
  '0x1666fe591e2f378091c7a9866d80da445fd3a1f3': {
    icon: Neiro,
    symbol: 'Neiro',
    chainId: base.id,
  }, //bNeiro
  '0xfdccd3180eb9fdc0fbac08d5a59b628c978f0fe8': {
    icon: BONK,
    symbol: 'BONK',
    chainId: base.id,
  }, //bBONK
  '0x2f225080c88934b211ef41f1247a88f6a1c30db6': {
    icon: FLOKI,
    symbol: 'FLOKI',
    chainId: base.id,
  }, //bFLOKI
  '0xc847511c793202c4ef86ae006d81baceeed8ff5c': {
    icon: BabyDoge,
    symbol: 'BabyDoge',
    chainId: base.id,
  }, //bBabyDoge
  '0x2943191025ae254a7546bddc57e6173826e4dbc7': {
    icon: DOGE,
    symbol: 'DOGE',
    chainId: base.id,
  }, //bDOGE
  '0x638bdc76db8aacc2cae4a4302334007ca300d4c9': {
    icon: SHIB,
    symbol: 'SHIB',
    chainId: base.id,
  }, //bSHIB
  '0xfdb933367b116f31b24116e761234e631092b7f2': {
    icon: PEPE,
    symbol: 'PEPE',
    chainId: base.id,
  }, //bPEPE
  '0x7510f51a66ce78c9932056b17c26bbbe9f56336d': {
    icon: CAT,
    symbol: 'CAT',
    chainId: base.id,
  }, //bCAT
  '0x9a26f5433671751c3276a065f57e5a02d2817973': {
    icon: KEYCAT,
    symbol: 'KEYCAT',
    chainId: base.id,
  }, //KEYCAT
  '0x6921b130d297cc43754afba22e5eac0fbf8db75b': {
    icon: DOGINME,
    symbol: 'DOGINME',
    chainId: base.id,
  }, //DOGINME
  '0xc803a27157b69f3eeafc3ff6af77b40e9d79274c': {
    icon: ELON,
    symbol: 'ELON',
    chainId: base.id,
  }, //bELON
  '0x100ce3e3391c00b6a52911313a4ea8d23c8a38d8': {
    icon: JOOCE,
    symbol: 'JOOCE',
    chainId: base.id,
  }, //JOOCE
}

export const assetsListBySymbol: {
  [key: string]: { address: Address; icon: string; symbol: string }
} = {
  CAI: { address: '0x48f88a3fe843ccb0b5003e70b4192c1d7448bef0', icon: CAI, symbol: 'CAI' }, //CAI
  ARTXAI: { address: '0x8e991e9edc300a538ce72186f5bcbc94f4bb9c80', icon: ARTX, symbol: 'ARTXAI' }, //ARTXAI
  JMX: { address: '0x83190636c344cf1220ffcbfc0c1198f7867b3667', icon: JMX, symbol: 'JMX' }, //JMX

  AVAX: { address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7', icon: WAVAX, symbol: 'AVAX' }, //AVAX
  ETH: { address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', icon: ETH, symbol: 'ETH' }, //ETH
  MATIC: { address: zeroAddress, icon: MATIC, symbol: 'MATIC' }, //MATIC
  USDC: { address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', icon: USDC, symbol: 'USDC' }, //USDC
  USDT: { address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', icon: USDT, symbol: 'USDT' }, //USDT
  LINK: { address: '0x514910771af9ca656af840dff83e8264ecf986ca', icon: LINK, symbol: 'LINK' }, //LINK
  WBTC: { address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', icon: WBTC, symbol: 'WBTC' }, //WBTC
  WETH: { address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', icon: ETH, symbol: 'WETH' }, //WETH
  JOE: { address: '0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd', icon: JOE, symbol: 'JOE' }, //JOE
  QI: { address: '0x8729438eb15e2c8b576fcc6aecda6a148776c0f5', icon: QI, symbol: 'QI' }, //QI
  WAVAX: { address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7', icon: WAVAX, symbol: 'WAVAX' }, //WAVAX
  sAVAX: { address: '0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be', icon: SAVAX, symbol: 'sAVAX' }, //sAVAX
  EPHTR: { address: '0x3b9805E163b3750e7f13a26B06F030f2d3b799F5', icon: ePHTR, symbol: 'ePHTR' }, //EPHTR
  XAVA: { address: '0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4', icon: XAVA, symbol: 'XAVA' }, //XAVA
  // INFO: COOKIE index assets
  GAME: { address: '0x1c4cca7c5db003824208adda61bd749e55f463a3', icon: GAME, symbol: 'GAME' }, //GAME
  COOKIE: { address: '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f', icon: COOKIE, symbol: 'COOKIE' }, //COOKIE
  LUNA: { address: '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4', icon: LUNA, symbol: 'LUNA' }, //LUNA
  VADER: { address: '0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870', icon: VADER, symbol: 'VADER' }, //VADER
  TOSHI: { address: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4', icon: TOSHI, symbol: 'TOSHI' }, //TOSHI
  VIRTUAL: {
    address: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
    icon: VIRTUAL,
    symbol: 'VIRTUAL',
  }, //VIRTUAL
  AIXBT: { address: '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825', icon: AIXBT, symbol: 'AIXBT' }, //AIXBT
  REI: { address: '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd', icon: REI, symbol: 'REI' }, //REI
  LAY: { address: '0xb89d354ad1b0d95a48b3de4607f75a8cd710c1ba', icon: LAY, symbol: 'LAY' }, //LAY
  CLANKER: {
    address: '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb',
    icon: CLANKER,
    symbol: 'CLANKER',
  }, //CLANKER
  SEKOIA: { address: '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7', icon: SEKOIA, symbol: 'SEKOIA' }, //SEKOIA
  AIXCB: { address: '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f', icon: AIXCB, symbol: 'AIXCB' }, //AIXCB

  COQ: { address: '0x420fca0121dc28039145009570975747295f2329', icon: COQ, symbol: 'COQ' }, //COQ
  ggAVAX: { address: '0xa25eaf2906fa1a3a13edac9b9657108af7b703e3', icon: GGAVAX, symbol: 'ggAVAX' }, //ggAVAX
  GGP: { address: '0x69260b9483f9871ca57f81a90d91e2f96c2cd11d', icon: GGP, symbol: 'GGP' }, //GGP
  CLY: { address: '0xec3492a2508ddf4fdc0cd76f31f340b30d1793e6', icon: CLY, symbol: 'CLY' }, //CLY
  //ARBITRUM ASSETS
  ARB: { address: '0x912ce59144191c1204e64559fe8253a0e49e6548', icon: ARB, symbol: 'ARB' }, //ABR arb-chain
  PENDLE: { address: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8', icon: PENDLE, symbol: 'PENDLE' }, //PENDLE arb-chain
  // LINK: { address: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4', icon: LINK, symbol: 'LINK' }, //LINK arb-chain
  GMX: { address: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a', icon: GMX, symbol: 'GMX' }, //GMX arb-chain
  OP: { address: '0x4200000000000000000000000000000000000042', icon: OP, symbol: 'OP' }, //OP optimism-chain
  //MATIC
  MATICX: { address: '0xfa68fb4628dff1028cfec22b4162fccd0d45efb6', icon: MATICX, symbol: 'MATICX' }, //MATICX
  ZETA: { address: '0x5f0b1a82749cb4e2278ec87f8bf6b618dc71a8bf', icon: ZETA, symbol: 'ZETA' }, //ZETA
  // INFO: JMX index assets
  WIF: { address: '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86', icon: WIF, symbol: 'WIF' }, //WIF
  SPX: { address: '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c', icon: SPX, symbol: 'SPX' }, //SPX
  MIGGLES: {
    address: '0xb1a03eda10342529bbf8eb700a06c60441fef25d',
    icon: MIGGLES,
    symbol: 'MIGGLES',
  }, //MIGGLES
  BENJI: { address: '0xbc45647ea894030a4e9801ec03479739fa2485f0', icon: BENJI, symbol: 'BENJI' }, //BENJI
  BRETT: { address: '0x532f27101965dd16442e59d40670faf5ebb142e4', icon: BRETT, symbol: 'BRETT' }, //BRETT
  DEGEN: { address: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed', icon: DEGEN, symbol: 'DEGEN' }, //DEGEN
  SKI: { address: '0x768be13e1680b5ebe0024c42c896e3db59ec0149', icon: SKI, symbol: 'SKI' }, //SKI
  Mog: { address: '0x2da56acb9ea78330f947bd57c54119debda7af71', icon: Mog, symbol: 'Mog' }, //Mog
  //+TOSHI + BRETT
  // INFO: JMX based assets
  bCOQ: { address: '0x1fb8432d5e243986df8ab85aea1dff5030ac54b6', icon: COQ, symbol: 'COQ' }, //bCOQ
  bTRUMP: { address: '0x87eedc11abe771273246172a4a922dea68796c2d', icon: TRUMP, symbol: 'TRUMP' }, //bTRUMP
  bMEME: { address: '0x7f3b6f46503a7fe22cbed587d94b5566c99a3f07', icon: MEME, symbol: 'MEME' }, //bMEME
  bNeiro: { address: '0x1666fe591e2f378091c7a9866d80da445fd3a1f3', icon: Neiro, symbol: 'Neiro' }, //bNeiro
  bBONK: { address: '0xfdccd3180eb9fdc0fbac08d5a59b628c978f0fe8', icon: BONK, symbol: 'BONK' }, //bBONK
  bFLOKI: { address: '0x2f225080c88934b211ef41f1247a88f6a1c30db6', icon: FLOKI, symbol: 'FLOKI' }, //bFLOKI
  bBabyDoge: {
    address: '0xc847511c793202c4ef86ae006d81baceeed8ff5c',
    icon: BabyDoge,
    symbol: 'BabyDoge',
  }, //bBabyDoge
  bDOGE: { address: '0x2943191025ae254a7546bddc57e6173826e4dbc7', icon: DOGE, symbol: 'DOGE' }, //bDOGE
  bSHIB: { address: '0x638bdc76db8aacc2cae4a4302334007ca300d4c9', icon: SHIB, symbol: 'SHIB' }, //bSHIB
  bPEPE: { address: '0xfdb933367b116f31b24116e761234e631092b7f2', icon: PEPE, symbol: 'PEPE' }, //bPEPE
  bCAT: { address: '0x7510f51a66ce78c9932056b17c26bbbe9f56336d', icon: CAT, symbol: 'CAT' }, //bCAT
  KEYCAT: { address: '0x9a26f5433671751c3276a065f57e5a02d2817973', icon: KEYCAT, symbol: 'KEYCAT' }, //KEYCAT
  DOGINME: {
    address: '0x6921b130d297cc43754afba22e5eac0fbf8db75b',
    icon: DOGINME,
    symbol: 'DOGINME',
  }, //DOGINME
  bELON: { address: '0xc803a27157b69f3eeafc3ff6af77b40e9d79274c', icon: ELON, symbol: 'ELON' }, //bELON
  JOOCE: { address: '0x100ce3e3391c00b6a52911313a4ea8d23c8a38d8', icon: JOOCE, symbol: 'JOOCE' }, //JOOCE
}

export const getAssetIconBySymbol = (symbol: string): string => {
  return Object.entries(assetsListBySymbol).find((item) => item[0] === symbol)?.[1].icon || PHTR
}

export const getAssetIconByAddress = (address: string): string => {
  return Object.entries(assetsList).find((item) => item[0] === address)?.[1].icon || PHTR
}
